export const initialFilters = {
    sorting: "",
    inStock: false,
    fastDelivery: false,
    priceRange: 600,
    rating: 0,
    category: []
  };